module.exports = __webpack_public_path__ + "static/media/1_A1_08.975a7b3c.png";